import { useState } from 'react'
import ChevronLeft from 'lucide-react/dist/esm/icons/chevron-left.mjs'
import ChevronRight from 'lucide-react/dist/esm/icons/chevron-right.mjs'
import Play from 'lucide-react/dist/esm/icons/play.mjs'

export function ReferenceMedia({ work }) {
  const [playing, setPlaying] = useState(false)
  const [videoActivated, setVideoActivated] = useState(false)
  const [imageIndex, setImageIndex] = useState(0)
  const isVideo = work.type === 'video'
  const images = Array.isArray(work.images) && work.images.length ? work.images : work.cover ? [work.cover] : []
  const imageCount = images.length || Number.parseInt(work.duration, 10) || 1
  const currentImage = images[imageIndex % Math.max(images.length, 1)] || work.cover
  const hasRealVideo = isVideo && typeof work.videoUrl === 'string' && /^https?:\/\//.test(work.videoUrl)
  const moveImage = (event, direction) => {
    event.stopPropagation()
    setImageIndex(current => (current + direction + imageCount) % imageCount)
  }
  const activateVideo = event => {
    event.stopPropagation()
    if (hasRealVideo) setVideoActivated(true)
    else setPlaying(current => !current)
  }
  return <div className={`inline-reference-media ${isVideo ? 'video-media' : 'image-media'}`}>
    {hasRealVideo && videoActivated
      ? <video className="inline-reference-video" src={work.videoUrl} poster={currentImage} controls autoPlay playsInline preload="auto" onClick={event => event.stopPropagation()}/>
      : <img src={currentImage} alt={`${work.title}封面`} loading="lazy" style={!isVideo ? { objectPosition: `${[50, 42, 58, 46][imageIndex % 4]}% center` } : undefined}/>} 
    {isVideo && !videoActivated ? <button className={`inline-play ${playing ? 'playing' : ''}`} onClick={activateVideo} aria-label={playing ? '暂停播放' : `播放 ${work.title}`}>{playing ? <><div className="playing-bars small"><i/><i/><i/><i/></div><span>播放中</span></> : <Play size={18}/>}</button> : !isVideo && imageCount > 1 ? <><button className="image-nav prev" aria-label="上一张" onClick={event => moveImage(event, -1)}><ChevronLeft size={17}/></button><button className="image-nav next" aria-label="下一张" onClick={event => moveImage(event, 1)}><ChevronRight size={17}/></button></> : null}
    {!videoActivated ? <div className="inline-media-bottom">{isVideo && playing ? <div className="inline-progress"><i/></div> : null}<span>{isVideo ? work.duration : `${imageIndex + 1} / ${imageCount}`}</span></div> : null}
  </div>
}
